const api = {
	heroku: {
		upload: async function (body) {
			if (!body) return null;

			const req = await fetch('https://evening-spire-07221.herokuapp.com/upload', {
				method: 'POST',
				body
			});

			const res = await req.json();

			if (!res.imageUrl) return null;

			return res.imageUrl;
		}
	},
	section: {
		get: async function (handle) {
			if (!handle) return null;

			const req = await fetch('/?sections=' + handle, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}
			});

			if (!req.ok) {
				const error = await req.json();
				throw error;
			}

			const res = await req.json();

			return res[handle];
		}
	},
	cart: {
		get: async function () {
			const req = await fetch('/cart.js', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}
			});

			if (!req.ok) {
				const error = await req.json();
				throw error;
			}

			const res = await req.json();

			return res;
		},
		add: async function ({ id = null, quantity = 1, properties = {} }) {
			if (!id) return null;

			const req = await fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({
					id,
					quantity,
					properties
				})
			});

			if (!req.ok) {
				const error = await req.json();
				throw error;
			}

			const res = await req.json();

			return res;
		},
		remove: async function ({ key = null }) {
			if (!key) return null;

			const req = await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({
					id: key,
					quantity: 0
				})
			});

			if (!req.ok) {
				const error = await req.json();
				throw error;
			}

			const res = await req.json();

			return res;
		},
		/**
		 * Updates a cart line item quantity.
		 *
		 * @param {object} params Function parameters.
		 * @param {string|null} params.key Cart line item key.
		 * @param {number} params.quantity Quantity to set.
		 * @returns {Promise<object|null>} Updated cart response.
		 */
		quantity: async function ({ key = null, quantity = 1 }) {
			if (!key) return null;

			const req = await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({
					id: key,
					quantity
				})
			});

			if (!req.ok) {
				const error = await req.json();
				throw error;
			}

			const res = await req.json();

			return res;
		},
		note: async function ({ note = '' }) {
			const req = await fetch('/cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({ note })
			});

			if (!req.ok) {
				const error = await req.json();
				throw error;
			}

			const res = await req.json();

			return res;
		}
	}
};

window.VermontGlove = window.VermontGlove || {};
window.VermontGlove.api = api;

export default api;
